const paIN= {
    login: {
      title: 'ਸਾਈਨ ਇਨ ਕਰੋ',
      sign_in_btn: 'ਸਾਈਨ ਇਨ ਕਰੋ'
    },
    bar: {
        logout: 'ਲਾਗ ਆਊਟ ਕਰੋ',
        languages: 'ਭਾਸ਼ਾਵਾਂ',
        settings: 'ਸੈਟਿੰਗਾਂ ਖੋਲ੍ਹੋ'
    },
    language: {
      name: 'ਪੰਜਾਬੀ (ਭਾਰਤ)',
    },
    attributePage: {
        title: 'ਵਿਸ਼ੇਸ਼ਤਾਵਾਂ ਵਿੱਚ ਬਦਲਾਅ',
        viewChanges: 'ਬਦਲਾਅ ਦੇਖੋ',
        dateTime: 'ਮਿਤੀ',
        notificationType: 'ਸੂਚਨਾ ਦੀ ਕਿਸਮ',
        notificationValue: 'ਸੂਚਨਾ ਦਾ ਮੁੱਲ',
        oldValue: 'ਪੁਰਾਣਾ ਮੁੱਲ',
        newValue: 'ਨਵਾਂ ਮੁੱਲ',
        accept: 'ਸਵੀਕਾਰ ਕਰੋ',
        reject: 'ਅਸਵੀਕਾਰ ਕਰੋ',
    },
    Home: 'ਹੋਮ',
    load: 'ਸ਼ੁਰੂਆਤੀ ਲੋਡ ਹੋ ਰਿਹਾ ਹੈ...',
    Requested: "ਬੇਨਤੀ ਕੀਤੀ ਗਈ",
    Viewed: "ਦੇਖਿਆ ਗਿਆ",
    Executing: "ਅਮਲ ਹੋ ਰਿਹਾ ਹੈ",
    Completed: "ਪੂਰਾ ਕੀਤਾ ਗਿਆ",
    Expired: "ਮਿਆਦ ਪੁੱਗ ਗਈ ਹੈ",
    Cancelled: "ਰੱਦ ਕੀਤਾ ਗਿਆ",
    Error: "ਤਰੁੱਟੀ",
    Rejected: "ਅਸਵੀਕਾਰ ਕੀਤਾ ਗਿਆ",
    error: 'ਕੁਝ ਗਲਤ ਹੋ ਗਿਆ; ਕਿਰਪਾ ਕਰਕੇ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ।',
    displayname: 'ਡਿਸਪਲੇ ਨਾਮ',
    givenname: 'ਨਾਮ',
    surname: 'ਉਪਨਾਮ',
    email: 'ਈਮੇਲ',
    mail: 'ਈਮੇਲ',
    name: 'ਨਾਮ',
    firstname: 'ਨਾਮ',
    lastname: 'ਉਪਨਾਮ',
    footer_copyright: 'ਸਾਰੇ ਹੱਕ ਰਾਖਵੇਂ ਹਨ।'
  };
  
  export default paIN;
  